/**
 * Formats an invoice amount to the cent, followed by its currency.
 * @function
 *
 * @param {number|string} value - The amount, as a number or a numeric string.
 * @param {string} currency - The currency unit ('€' or 'Fr').
 * @returns {string} The amount with two decimals, 0 when it is missing or not a number.
 */
export const formatInvoiceAmount = (value, currency) =>
  `${(Number(value) || 0).toFixed(2)} ${currency}`;
